import React from 'react';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { EnrichedOwnership } from '../../../hooks/useEnrichedCollection';
import CollectionCard from './CollectionCard';

interface CollectionGridProps {
  cards: EnrichedOwnership[];
  totalCards: number;
  searchTerm: string;
  onMenuClick: (event: React.MouseEvent<HTMLElement>, cardId: string) => void;
  observerRef?: React.RefObject<HTMLDivElement>;
  isLoadingMore?: boolean;
}

const CollectionGrid: React.FC<CollectionGridProps> = ({
  cards,
  totalCards,
  searchTerm,
  onMenuClick,
  observerRef,
  isLoadingMore,
}) => {
  // Empty State
  if (cards.length === 0) {
    return (
      <Box textAlign="center" py={5}>
        <Typography variant="h6" color="textSecondary">
          {searchTerm
            ? 'No results found.'
            : 'Your collection is empty. Start adding cards!'}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Grid container spacing={2}>
        {cards.map((card, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={2}
            key={`${card.game}-${card.id}-${index}`}
          >
            <CollectionCard card={card} onMenuClick={onMenuClick} />
          </Grid>
        ))}
      </Grid>

      {/* Infinite Scroll Loading Indicator */}
      {isLoadingMore && cards.length < totalCards && (
        <Box
          ref={observerRef}
          display="flex"
          justifyContent="center"
          alignItems="center"
          py={4}
        >
          <CircularProgress />
          <Typography variant="body2" color="textSecondary" ml={2}>
            Loading more cards... ({cards.length} of {totalCards})
          </Typography>
        </Box>
      )}

      {/* All cards loaded indicator */}
      {cards.length > 0 && cards.length === totalCards && totalCards > 50 && (
        <Box textAlign="center" py={4}>
          <Typography variant="body2" color="textSecondary">
            All {totalCards} cards loaded
          </Typography>
        </Box>
      )}
    </>
  );
};

export default CollectionGrid;
